import { render, staticRenderFns } from "./bulma_graph.vue?vue&type=template&id=023d385b&scoped=true&lang=html"
import script from "./bulma_graph.vue?vue&type=script&lang=js"
export * from "./bulma_graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d385b",
  null
  
)

export default component.exports